import React, { useEffect } from "react";
import { loadTermlyScript } from "./termly_script";

const EMBED_DATA_ID = "93e60820-8be4-4815-be58-525dd9e9d0a6";

export function PrivacyPolicyRender(): React.ReactElement {
  useEffect(() => {
    loadTermlyScript();
  }, []);

  const divProps: React.HTMLAttributes<HTMLDivElement> & { name: string; "data-id": string } = {
    name: "termly-embed",
    "data-id": EMBED_DATA_ID,
  };
  return <div {...divProps} />;
}
